import { useCallback } from "react";
import * as Actions from "../actions";
import { useDomainUseCase } from "./useDomainUseCase";

export const useUserLiveSessionDomainActions = () => {
  const { execute } = useDomainUseCase();

  const createUserLiveSession = useCallback((liveSessionId) => {
    execute({
      useCase: "CreateUserLiveSessionUseCase",
      params: { liveSessionId },
      getLoadingAction: Actions.createUserLiveSession,
      getErrorAction: Actions.createUserLiveSessionError,
      getSuccessAction: Actions.createUserLiveSessionSuccess,
    });
  }, []);

  const finishUserLiveSession = useCallback((liveSessionId) => {
    execute({
      useCase: "FinishUserLiveSessionUseCase",
      params: { liveSessionId },
      getLoadingAction: Actions.finishUserLiveSession,
      getErrorAction: Actions.finishUserLiveSessionError,
      getSuccessAction: Actions.finishUserLiveSessionSuccess,
    });
  }, []);

  return {
    createUserLiveSession,
    finishUserLiveSession,
  };
};
